import { AbstractControl } from '@angular/forms';

export function getErrorKey(err: any): string | undefined {
  const data = err?.error?.data;
  if (!data) return undefined;
  // Server may return a plain string key
  if (typeof data === 'string') return data;
  // Or array of field errors: [{ field, errors: ['KEY'] }]
  if (Array.isArray(data) && data.length) {
    const first = data[0];
    if (first && Array.isArray(first.errors) && first.errors.length) {
      return first.errors[0];
    }
  }
  return undefined;
}

export function applyErrors(form: AbstractControl, d: any) {
  const data = d?.error?.data;
  if (!Array.isArray(data)) return;
  for (const err of data) {
    if (!Array.isArray(err.errors) || !err.errors.length) continue;
    const control = form.get(err.field);
    const errCode = err.errors[0];

    if (control) {
      control.setErrors({ [errCode]: true });
    }
  }
}
